import {
  CheckCircleIcon,
  InfoIcon,
  WarningCircleIcon,
  WarningIcon,
  XIcon,
} from "@phosphor-icons/react";
import { Toaster as SonnerToaster, type ToasterProps as SonnerToasterProps } from "sonner";
import { Spinner } from "./spinner";

export { toast } from "sonner";

export type ToasterProps = Omit<SonnerToasterProps, "toastOptions" | "icons" | "richColors">;

/*
 * Sonner como motor, visual do DS (o mesmo do `Toast`): vidro surface-hi,
 * borda hi, sombra pop, raio md. A severidade colore só o ícone.
 */
const CLASS_NAMES = {
  toast:
    "flex w-(--width) items-start gap-3 max-sm:w-full rounded-md border border-border-hi bg-surface-hi px-3.5 py-3 font-sans text-[13px] text-fg shadow-pop",
  content: "flex flex-1 flex-col gap-0.5",
  title: "font-medium text-fg",
  description: "text-[12.5px] leading-normal text-muted",
  icon: "mt-px shrink-0",
  success: "[&_[data-icon]]:text-success",
  error: "[&_[data-icon]]:text-error",
  warning: "[&_[data-icon]]:text-warning",
  info: "[&_[data-icon]]:text-info",
  loading: "[&_[data-icon]]:text-accent",
  closeButton:
    "order-last flex shrink-0 cursor-pointer border-0 bg-transparent p-0.5 text-muted-2 hover:text-fg",
  actionButton:
    "shrink-0 cursor-pointer border-0 bg-transparent text-[12.5px] font-medium text-accent hover:underline",
  cancelButton:
    "shrink-0 cursor-pointer border-0 bg-transparent text-[12.5px] font-medium text-muted hover:text-fg",
};

const ICONS = {
  success: <CheckCircleIcon size={16} weight="regular" />,
  error: <WarningCircleIcon size={16} weight="regular" />,
  warning: <WarningIcon size={16} weight="regular" />,
  info: <InfoIcon size={16} weight="regular" />,
  loading: <Spinner size="sm" />,
  close: <XIcon size={13} weight="regular" />,
};

/** Host global das notificações (`toast.success(...)`). Montado uma vez pelo shell. */
export function Toaster({
  position = "top-right",
  closeButton = true,
  mobileOffset = 12,
  className,
  ...props
}: ToasterProps) {
  return (
    <SonnerToaster
      position={position}
      closeButton={closeButton}
      mobileOffset={mobileOffset}
      // Mobile: o sonner usa `width: 100%` + offsets laterais, o que passa da tela.
      className={["max-sm:w-auto!", className].filter(Boolean).join(" ")}
      icons={ICONS}
      toastOptions={{ unstyled: true, classNames: CLASS_NAMES, closeButtonAriaLabel: "Fechar" }}
      {...props}
    />
  );
}
